import { useMemo } from 'react'
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'
import { useBooleanFlagValue } from '@openfeature/react-sdk'
import { Icon, Breadcrumb } from '@/ui'
import { FEATURE_FLAG_KEYS } from '@/features/open-feature'
import { useNavigate } from 'react-router-dom'

export const InsightBreadcrumb = ({
  month,
  year,
}: {
  month?: string | number | null
  year?: string | number | null
}) => {
  const navigate = useNavigate()
  const shouldDisplayPracticeInsights = useBooleanFlagValue(
    FEATURE_FLAG_KEYS.consolidatedReportsFinancialOverview,
    false
  )

  const insightsLink = useMemo(() => {
    let baseLink = '/insights/overview?'
    if (month) {
      baseLink += `month=${month}&`
    }
    if (year) {
      baseLink += `year=${year}`
    }
    return baseLink
  }, [month, year])

  if (!shouldDisplayPracticeInsights) {
    return null
  }

  return (
    <Breadcrumb>
      <Breadcrumb.List>
        <Breadcrumb.Item>
          <Breadcrumb.Link
            onClick={() => {
              navigate(insightsLink)
            }}
          >
            <Icon icon={regular('arrow-left')} className="mr-2" />
            Back to Practice Insights
          </Breadcrumb.Link>
        </Breadcrumb.Item>
      </Breadcrumb.List>
    </Breadcrumb>
  )
}
